import React, { useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import { getFileTarget } from "../../../services/api/file_upload";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import { isMobileDevice } from "../../../services/mobile";

const useStyles = makeStyles({
  menuIcon: {
    fontSize: "25px",
  },
  menuText: {
    fontSize: "0.8rem",
    textTransform: "uppercase",
  },
  listItem: {
    color: "#9b9b9b;",
  },
  selected: {
    background: "rgba(46,91,255,.1)",
  },
  avatar: {
    height: 30,
    width: 30,
  },
  addRow: {
    color: "white",
    background: "#0083c9",
    "&:hover": {
      color: "#0083c9",
    },
  },
  addRowIcon: {
    color: "white",
  },
  addRowIconHovered: {
    color: "#0083c9",
  },
  logoutRow: {
    color: "#df6767",
  },
});

function ExpandedMenuItem({
  icon,
  avatar,
  label,
  selected,
  onMenuItemClick,
  subMenu,
  expanded,
  muiIcon,
  addRow,
  logoutRow,
  secondaryLabel,
}) {
  const classes = useStyles();
  const [addRowHovered, setAddRowHovered] = useState(false);

  return (
    <ListItem
      button
      className={`${classes.listItem} ${selected ? classes.selected : ""} ${
        addRow ? classes.addRow : ""
      }`}
      onClick={onMenuItemClick}
      onMouseEnter={() => setAddRowHovered(true)}
      onMouseLeave={() => setAddRowHovered(false)}
    >
      {!avatar && muiIcon && (
        <ListItemIcon
          className={`${classes.avatar} ${addRow ? classes.addRowIcon : ""} ${
            addRowHovered && addRow ? classes.addRowIconHovered : ""
          }`}
        >
          {muiIcon()}
        </ListItemIcon>
      )}
      {!muiIcon && icon && (
        <ListItemIcon>
          <i className={`${classes.menuIcon} ${icon}`} />
        </ListItemIcon>
      )}
      {avatar && (
        <ListItemAvatar>
          <Avatar
            src={getFileTarget(avatar, "100x100")}
            alt="avatar"
            className={classes.avatar}
          />
        </ListItemAvatar>
      )}
      <ListItemText
        primary={label}
        primaryTypographyProps={{
          className: classes.menuText,
        }}
        className={logoutRow ? classes.logoutRow : ""}
        secondary={secondaryLabel}
      />
      {isMobileDevice() && subMenu && expanded && <ExpandLess />}
      {isMobileDevice() && subMenu && !expanded && <ExpandMore />}
    </ListItem>
  );
}

export default ExpandedMenuItem;
